import getAllTiposIndicador from "entity/TipoIndicador/all"
import _ from 'lodash'
import LaudoVisita from "entity/LaudoVisita"
import Cliente from "entity/Cliente"

const rUn = (v) => {
    if (v === undefined) {
        return "NI"
    }
    return v
}

const getValueGroupParam = (a, groupByConfig) => {
    if (!groupByConfig) {
        return "Período"
    }
    if (groupByConfig.param === "Por mês") {
        let split = a.dataRef.split("-")
        return split[0] + "-" + split[1]
    }
    if (groupByConfig.param.includes('talhao')) {
        let nomeTalhao = _.get(a, groupByConfig.param)
        if (!nomeTalhao || nomeTalhao === undefined) {
            let nomeTalhoesOriginal = ''
            let talhoes = a.talhao
            let orderedTalhoes = talhoes.sort(function (a, b) {
                // Converte os valores para números antes de comparar
                var nomeA = parseInt(a.nome)
                var nomeB = parseInt(b.nome)

                if (nomeA < nomeB) {
                    return -1
                }
                if (nomeA > nomeB) {
                    return 1
                }
                return 0
            })

            for (let i = 0; i < orderedTalhoes.length; i++) {
                nomeTalhoesOriginal = nomeTalhoesOriginal + orderedTalhoes[i].nome + ", "
            }

            let nomeTalhoesModified = nomeTalhoesOriginal.slice(0, -2)
            nomeTalhoesModified = nomeTalhoesModified.replace(/,([^,]*)$/, ' e$1')

            return nomeTalhoesModified
        }
    }
    return rUn(_.get(a, groupByConfig.param))
}

const getNameGroup = (a, groupByConfig) => {
    if (!groupByConfig) {
        return "Período"
    }
    if (groupByConfig.param === "Por mês") {
        let split = a.dataRef.split("-")
        return split[1] + "/" + split[0]
    }
    if (groupByConfig.param === "equipamento") {
        const getEquipamentoType = _.get(a, groupByConfig.param)
        // check if getEquipamentoType is an object
        if (typeof getEquipamentoType === 'object') {
            return rUn(_.get(a, (groupByConfig?.paramNameShow)))
        }
        // check if there is an equipamento
        if (getEquipamentoType) {
            return rUn(_.get(a, (groupByConfig?.param)))
        }
    }
    if (groupByConfig.param === "frente") {
        const getFrenteType = _.get(a, groupByConfig.param)
        // check if getFrenteType is an object
        if (typeof getFrenteType === 'object') {
            return rUn(_.get(a, (groupByConfig?.paramNameShow)))
        }
        // check if there is an equipamento
        if (getFrenteType) {
            return rUn(_.get(a, (groupByConfig?.param)))
        }
    }
    if (groupByConfig.param.includes('talhao')) {
        let nomeTalhao = _.get(a, groupByConfig.param)
        if (!nomeTalhao || nomeTalhao === undefined) {

            let nomeTalhoesOriginal = ''

            let talhoes = a.talhao

            let orderedTalhoes = talhoes.sort(function (a, b) {
                // Converte os valores para números antes de comparar
                var nomeA = parseInt(a.nome)
                var nomeB = parseInt(b.nome)

                if (nomeA < nomeB) {
                    return -1
                }
                if (nomeA > nomeB) {
                    return 1
                }
                return 0
            })

            for (let i = 0; i < orderedTalhoes.length; i++) {
                nomeTalhoesOriginal = nomeTalhoesOriginal + orderedTalhoes[i].nome + ", "
            }

            let nomeTalhoesModified = nomeTalhoesOriginal.slice(0, -2)
            nomeTalhoesModified = nomeTalhoesModified.replace(/,([^,]*)$/, ' e$1')

            return nomeTalhoesModified
        }
    }

    return rUn(_.get(a, (groupByConfig?.paramNameShow || groupByConfig.param)))
}

const calcMedias = (IndicadorEntity, groupByConfig, apontamentos, paramsCliente, parseDuration, cliente) => { // pdf da tela de relatórios e tela de relatórios
    let mapResult = {}

    labeling(apontamentos, mapResult, groupByConfig, paramsCliente)

    for (const key in mapResult) {
        if (Object.hasOwnProperty.call(mapResult, key)) {
            const grupo = mapResult[key];
            if (!_.isEmpty(grupo.apontamentos)) {
                let media = _.meanBy(grupo.apontamentos, (a) => parseFloat(_.get(a, 'conformidade', 0)));
                grupo.media = media.toFixed(2)

                if (paramsCliente) {
                    // pega os parametros do cliente do primeiro laudo retornado pelo BD
                    let auxCliente = apontamentos && apontamentos.length && apontamentos[0].laudoRef && apontamentos[0].laudoRef.cliente ? apontamentos[0].laudoRef.cliente : cliente
                    grupo.status = IndicadorEntity.getConformidadeStatus(media, paramsCliente.meta, null, getClient(auxCliente))
                    grupo.color = IndicadorEntity.getColorStatus(grupo.status);
                }
            }
        }
    }

    let resutArray = Object.values(mapResult);
    resutArray.sort((a, b) => a.groupNameShow > b.groupNameShow ? 1 : -1)
    return resutArray;
}

const getTiposIndicadoresUsar = (tiposIndicador) => {
    if (tiposIndicador && tiposIndicador.length > 0) {
        return _.uniq(tiposIndicador.map(ind => ind.type))
    }

    return getAllTiposIndicador()
}

const getIndicadoresUsar = (tiposIndicador, indicadoresPossiveis) => {
    if (tiposIndicador && tiposIndicador.length > 0) {
        return tiposIndicador
    }

    return indicadoresPossiveis
}

const validObj = async (laudo, ativaInicializadorTeste, tiposIndicador) => {
    let entity = new LaudoVisita()
    entity.update(laudo)
    if (ativaInicializadorTeste) {

        for (const TipoClass of getAllTiposIndicador()) {
            await TipoClass.onLoad(entity);
        }
    }

    if (tiposIndicador && tiposIndicador.length) {
        let axo = false;
        for (const TipoClass of getTiposIndicadoresUsar(tiposIndicador)) {
            if (!axo) {
                for (const IndicadorClass of tiposIndicador) {
                    let ap = _.get(entity.data, `apontamentos.${TipoClass.field}.${IndicadorClass.constructor.field}`)
                    if (ap) {
                        axo = true;
                        break
                    }
                }
            } else {
                break
            }
        }
        if (!axo) {
            return null;
        }
    }


    if (!entity.data.strIndicadores) {
        entity.data.strIndicadores = LaudoVisita.generateStrIndicador(entity.data)
    }

    return entity.data;
}

export const requiredMsgFunc = (
    cliente,
    dataInicio,
    dataFim,
    actionsOnRequiredActive,
    setMsgFilter,
    setGlobalLoading
) => {
    let msg = ["Informe "]
    if (!cliente) {
        msg.push("um Cliente")
    }
    if (!dataInicio && !dataFim) {
        if (msg.length > 1) {
            msg.push(", Data de Início e Data de Fim")
        } else {
            msg.push("Data de Início e Data de Fim")
        }
    } else if (!dataInicio && dataFim) {
        if (msg.length > 1) {
            msg.push(" e Data de Início")
        } else {
            msg.push("Data de Início")
        }
    } else if (dataInicio && !dataFim) {
        if (msg.length > 1) {
            msg.push(" e Data de Fim")
        } else {
            msg.push("Data de Fim")
        }
    }

    if (msg.length > 1) {
        actionsOnRequiredActive()
        setMsgFilter(`${msg.join("")}`)
        return
    } else {
        setMsgFilter("")
    }
    setGlobalLoading("")
}

export const listaAgrupadores = () => {
    return [
        { nome: "Frente", param: "frente", paramNameShow: "frenteObj.frente" },
        { nome: "Turno", param: "turno" },
        { nome: "Equipamento", param: "equipamento.equipamento", paramNameShow: "equipamento.equipamento" },
        { nome: "Talhão", param: "talhao.nome" },
        { nome: "Fazenda", param: "laudoRef.fazenda.uid", paramNameShow: "laudoRef.fazenda.codFazenda" },
        { nome: "Insumo", param: "insumo.uid", paramNameShow: "insumo.nome" },
        { nome: "Mês", param: "Por mês", },
        { nome: "Cliente", param: "laudoRef.cliente.nome" },
    ]
}

export const getClient = (cliente) => {
    if (cliente && Array.isArray(cliente)) {
        return cliente[0]
    }

    return cliente
}

export const getTipoPerfil = (perfil, setTipoPerfil) => {
    if (perfil) {
        if (perfil.grupoPermissao) {
            if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                setTipoPerfil('admin')
            }
            if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                setTipoPerfil('tecnico')
            }
            if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                setTipoPerfil('lider')
            }
        }
    }
}

export const getQuery = (cliente, fazenda, tecnico, dataInicio, dataFim) => {
    let query = LaudoVisita.collection

    if (cliente && cliente.length) {
        let uids = cliente.map(cliente => cliente.uid)
        query = query.where('cliente.uid', 'in', uids)
    }

    if (fazenda) {
        query = query.where('fazenda.uid', '==', fazenda.uid)
    }
    if (tecnico) {
        query = query.where('tecnico.uid', '==', tecnico.uid)
    }
    query = query.where("dataStr", ">=", dataInicio.replaceAll("-", ""))
    query = query.where("dataStr", "<=", dataFim.replaceAll("-", ""))

    return query
}

export const getQueryMassUpdate = (cliente, status, dataInicio, dataFim) => {
    let query = LaudoVisita.collection

    if (cliente) {
        query = query.where('cliente.uid', '==', cliente.uid)
    }

    if (status) {
        query = query.where('status', '==', status)
    }

    query = query.where("dataStr", ">=", dataInicio.replaceAll("-", ""))
    query = query.where("dataStr", "<=", dataFim.replaceAll("-", ""))

    query = query.orderBy("dataStr", "desc")

    return query
}

export const filterSnapshot = async (
    qs,
    ativaInicializadorTeste,
    tiposIndicador,
    cliente,
    clienteOld,
    setTecnicosPossiveis,
    setLaudos,
    setGlobalLoading
) => {
    let l = [];
    if (!qs.empty) {

        for (let index = 0; index < qs.docs.length; index++) {
            const doc = qs.docs[index];

            let laudo = await validObj(
                doc.data(),
                ativaInicializadorTeste,
                tiposIndicador
            )
            if (laudo) {
                // não exibe laudos "deletados"
                if (laudo.status !== 'Cancelado') {
                    l.push(laudo)
                }
            }
        }
    }
    console.log('return laudos', l.length)


    // pega os parametros do cliente do primeiro laudo retornado pelo BD
    let auxCliente = l && l.length && l[0].cliente ? l[0].cliente : cliente
    if (l.length && getClient(auxCliente) !== clienteOld) {
        let tecnicos = []
        let tecnicosUIDs = []

        l.forEach(laudo => {
            if (!tecnicos.length) {
                tecnicos.push(laudo.tecnico)
                tecnicosUIDs.push(laudo.tecnico?.uid)
            } else if (!tecnicosUIDs.includes(laudo.tecnico?.uid)) {
                tecnicos.push(laudo.tecnico)
                tecnicosUIDs.push(laudo.tecnico?.uid)
            }
        })

        if (tecnicos.length) {
            setTecnicosPossiveis(tecnicos)
        }
    }

    setLaudos(l);
    setGlobalLoading("")
}

// percorre cada apontamento rotulando conforme o seletor "Agrupador"
// se o agrupador é "Frente":
//     - percorre cada apontamento criando uma lista de "Frentes" e rotulando cada apontamento conforme o valor de "Frente" dele;
//     - o resultado pode ser por exemplo: NI, Agro Bento, Própria, Agro Naviraí.
export const labeling = (apontamentos, mapResult, groupByConfig, paramsCliente) => {
    apontamentos.forEach(a => {
        let r = _.get(mapResult, getValueGroupParam(a, groupByConfig))
        if (!r) {
            r = { group: getValueGroupParam(a, groupByConfig), groupNameShow: getNameGroup(a, groupByConfig), apontamentos: [] }
            _.set(mapResult, getValueGroupParam(a, groupByConfig), r)
            r.meta = paramsCliente?.meta
            r.groupNameShow = r.groupNameShow.trim()
        }
        r.apontamentos.push(a)
    })
}

// gráfico da tela de relatórios
export const prepareFilterData = (laudos, cliente, tipoPerfil, tiposIndicador, indicadoresPossiveis, agrupadoresRel, agrupador, parseDuration, setApontamentosPorTipo) => {
    // pega os parametros do cliente do primeiro laudo retornado pelo BD
    let auxCliente = laudos && laudos.length && laudos[0].cliente ? laudos[0].cliente : cliente
    auxCliente = getClient(auxCliente)
    // admin consegue puxar todos clientes, então não precisa do filtro de cliente
    if (laudos && (auxCliente || tipoPerfil === 'admin')) {
        let tipoIndicadorAponts = {}

        laudos.forEach(laudo => {
            for (const TipoClass of getTiposIndicadoresUsar(tiposIndicador)) {
                for (const IndicadorClass of getIndicadoresUsar(tiposIndicador, indicadoresPossiveis)) {
                    let indField = `${TipoClass.field}.${IndicadorClass.constructor.field}`
                    let aps = _.get(laudo, `apontamentos.${indField}`)

                    if (aps) {
                        aps.forEach(ap => {
                            ap.laudoRef = laudo
                            if (!ap.dataStr) {
                                ap.dataRef = laudo.data.split('/').reverse().join("-")
                            }
                        });

                        let atual = _.get(tipoIndicadorAponts, `${indField}.apontamentos`)
                        if (!atual) {
                            atual = []
                        }

                        let concat = atual.concat(aps)

                        let paramsCliente = Cliente.getParamsClienteData(
                            (auxCliente || laudos[0].cliente),
                            IndicadorClass.constructor,
                            false,
                            TipoClass
                        )
                        let groupByConfig = agrupadoresRel[agrupadoresRel.map(t => t.nome).indexOf(agrupador)]
                        let mediaAgrupadorList = calcMedias(IndicadorClass.constructor, groupByConfig, concat, paramsCliente, parseDuration, cliente)

                        _.set(tipoIndicadorAponts, `${indField}.IndicadorClass`, IndicadorClass)
                        _.set(tipoIndicadorAponts, `${indField}.apontamentos`, concat)
                        _.set(tipoIndicadorAponts, `${indField}.agrupador`, groupByConfig)
                        _.set(tipoIndicadorAponts, `${indField}.mediaAgrupadorList`, mediaAgrupadorList)
                        _.set(tipoIndicadorAponts, `${indField}.paramsCliente`, paramsCliente)

                    }
                }
            }
        });

        setApontamentosPorTipo(tipoIndicadorAponts)
    } else {
        setApontamentosPorTipo(null)
    }
}

export const filterValidation = (actionsOnRequiredActive, setMsgFilter, setGlobalLoading, clienteOld, setFiltersOld, filters, filterOnClick) => {
    requiredMsgFunc(getClient(filters.cliente), filters.dataInicio, filters.dataFim, actionsOnRequiredActive, setMsgFilter, setGlobalLoading)

    // executa a query somente ao mudar o cliente
    if (filters.cliente !== clienteOld) {
        filterOnClick()
    } else {
        // se mudou os outros filtros, o usuário deve clicar no botão "FILTRAR" p/ executar a query
        setMsgFilter("Clique no botão filtrar p/ atualizar o resultado")
    }
    setFiltersOld(filters)
}